import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { FileTypeEnum, IFile } from '@repo/toolkit/types'
import { CameraIcon, PenIcon, UserFourIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { useModalManager } from '../../../lib/hooks/use-modal-manager'

type Props = {
  picture?: Pick<IFile, 'path'> | null
  onUpdateProfilePicture: (file: IFile) => void
  disabled?: boolean
}

const StaffPersonalSpacePictureUpload = ({ picture, onUpdateProfilePicture, disabled }: Props) => {
  const { toggleModal } = useModalManager(['profilePictureModal'])
  const ref = useRef<HTMLInputElement>(null)

  return (
    <div className={cn('relative w-fit', { 'pointer-events-none': disabled })}>
      <input
        type="file"
        hidden
        ref={ref}
        accept="image/*"
        onChange={(e) => {
          const file = e.target.files?.[0]
          if (file)
            onUpdateProfilePicture({
              name: file.name,
              size: file.size,
              path: URL.createObjectURL(file),
              type: FileTypeEnum.IMAGE
            })
        }}
      />
      <div className="rounded-2xl w-20 h-20 object-cover bg-grey-light-hover flex justify-center items-center ">
        {picture ? (
          <img
            src={picture?.path}
            alt="profile"
            className="w-full h-full object-cover rounded-2xl cursor-pointer"
            onClick={() => {
              toggleModal('profilePictureModal')
            }}
          />
        ) : (
          <UserFourIcon filled className="w-full h-full" color={tailwindColors.white.DEFAULT} />
        )}
      </div>
      <div
        className="bg-white w-8 h-8 rounded-full absolute bottom-0 -right-2 flex justify-center items-center cursor-pointer group p-[2px] "
        onClick={() => {
          ref.current?.click()
        }}
      >
        <div
          className={cn('w-full h-full rounded-full flex justify-center items-center p-[2px]', {
            'bg-primary': !picture,
            'bg-secondary-light': picture
          })}
        >
          {picture ? (
            <PenIcon
              className="w-4 h-4"
              color={tailwindColors.secondary.DEFAULT}
              fill={tailwindColors.fushia.DEFAULT}
            />
          ) : (
            <CameraIcon className="w-full h-full" />
          )}
        </div>
      </div>
    </div>
  )
}

export default StaffPersonalSpacePictureUpload
